/**
 * Main entry point
 * SeeByEar Workshop App
 *
 * 主入口点
 * SeeByEar工作坊应用
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthStore } from './stores/authStore'

// Styles
import './assets/styles/index.css'

// Create Vue app
const app = createApp(App)

// Install plugins
app.use(createPinia())
app.use(router)
app.use(i18n)

// Initialize auth before mounting
const authStore = useAuthStore()
authStore.init().then(() => {
  app.mount('#app')
})
